import { useMemo } from "react";
import jwt_decode from "jwt-decode";
import { getJwtToken } from "../../../services/jwt.services";

const useScriptPermissions = () => {
  const permissions = useMemo(() => {
    const jwtToken = getJwtToken();
    if (!jwtToken) {
      return {
        canRead: false,
        canWrite: false,
        isAdmin: false,
        isGlobalAdmin: false,
      };
    }

    try {
      const decoded = jwt_decode(jwtToken);
      const scriptRunnerv2Permissions = decoded.scriptRunnerv2permissions || [];
      const globalPermissions = decoded.permissions || [];
      const companiesPermissions = decoded.companiespermissions || [];

      const isGlobalAdmin =
        globalPermissions.includes("admin") ||
        companiesPermissions.includes("admin");
      const isScriptAdmin = scriptRunnerv2Permissions.includes("admin");
      const isScriptWriter = scriptRunnerv2Permissions.includes("write");
      const isScriptReader = scriptRunnerv2Permissions.includes("read");

      return {
        canRead:
          isGlobalAdmin || isScriptAdmin || isScriptWriter || isScriptReader,
        canWrite: isGlobalAdmin || isScriptAdmin || isScriptWriter,
        isAdmin: isGlobalAdmin || isScriptAdmin,
        isGlobalAdmin,
      };
    } catch (error) {
      console.error("Error decoding JWT for script permissions:", error);
      return {
        canRead: false,
        canWrite: false,
        isAdmin: false,
        isGlobalAdmin: false,
      };
    }
  }, []);

  return permissions;
};

export default useScriptPermissions;
